/**
 * Pricing Functions
 *
 * Functions for pricing calculations, buy flow, and design changes.
 */

import { api } from "../api";
import { toastSuccess, toastError } from "../ui/messages";
import { closeModalLast } from "../ui/modal";
import { getDomElement, getDomElementOrThrow } from "../utils/dom";

/**
 * Reverse earning calculation
 */
export function earningcalcrev(num: number): number {
  const mid = 20;

  if (num === 50) {
    num = mid;
  } else {
    if (num > 50) {
      const diff = (num - 50) / 50;
      num = 20 + 80 * diff;
    } else {
      const diff = (50 - num) / 50;
      num = 20 - 20 * diff;
    }
  }

  return Math.round(num);
}

/**
 * Calculate and display pricing based on markup slider
 */
export function calcPricing(id: string): void {
  const products_total = 5;
  let products_loop = 1;

  const markupValue = getDomElement<HTMLInputElement>(`markup-${id}`)?.value;
  const markup = earningcalcrev(parseInt(markupValue ?? "50"));

  const pictufy_markup = 0.2;

  while (products_loop !== products_total) {
    const base_price_str = getDomElementOrThrow<HTMLInputElement>(
      `base-price-${products_loop}`
    )?.value;
    const recommended_price = getDomElement(`price${products_loop}-1`)?.innerHTML ?? "";

    const base_price_num = Number(base_price_str);
    const pictufy_earning = base_price_num * pictufy_markup;
    const your_earning = base_price_num * (markup / 100);

    const final_price = base_price_num + pictufy_earning + your_earning;

    const diff = Number(recommended_price.replace(/\$/g, "")) / final_price;

    let color = "#B43939";
    if (diff > 0.7) color = "#B49C39";
    if (diff > 0.9) color = "#3DB439";

    const priceEl = getDomElement(`price${products_loop}-2`);
    if (priceEl) {
      priceEl.innerHTML = `<span style="color: ${color};">$${final_price.toFixed(0)}</span>`;
    }

    products_loop++;
  }
}

export async function savePricing(id: string): Promise<void> {
  const markupEl = getDomElement<HTMLInputElement>("markup-" + id);
  if (markupEl === null) return;

  let option = 1;
  const opt2 = getDomElement<HTMLInputElement>("pricing-option-2");
  const opt3 = getDomElement<HTMLInputElement>("pricing-option-3");
  if (opt2?.checked) option = 2;
  if (opt3?.checked) option = 3;

  const markup = earningcalcrev(parseFloat(markupEl.value));

  try {
    await api.artists.savePricing({ id: Number(id), markup, option });
    closeModalLast();
    toastSuccess("Pricing saved");
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}
